if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Supporto per featured-blog
        const isBlog = this.tagName.toLowerCase() === 'featured-blog';
        
        this.selectors = {
          sliderWrapper: isBlog ? '.featured-blog__items' : '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        if (isBlog) {
          this.sectionId = this.dataset.sectionId;
          this.block = this.closest('.featured-blog__content');
        } else {
          this.blockId = this.dataset.blockId;
          this.block = this.closest(`[data-id="${this.blockId}"`);
        }
        
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        if (!this.sliderWrapper) {
          console.warn(isBlog ? 'Featured Blog' : 'Featured Collection', ': sliderWrapper not found');
          return;
        }

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 3;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
        this.laptopItems = isBlog ? this.tabletItems : parseInt(this.dataset.laptopItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (typeof window.FoxTheme === 'undefined' || typeof window.FoxTheme.Carousel === 'undefined') {
          console.warn(isBlog ? 'Featured Blog' : 'Featured Collection', ': FoxTheme.Carousel not available');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        
        if (!this.block) {
          const isBlog = this.tagName.toLowerCase() === 'featured-blog';
          console.warn(isBlog ? 'Featured Blog' : 'Featured Collection', ': block container not found');
          return;
        }

        const nextButton = this.block.querySelector(this.selectors.nextEl);
        const prevButton = this.block.querySelector(this.selectors.prevEl);
        
        if (!nextButton || !prevButton) {
          const isBlog = this.tagName.toLowerCase() === 'featured-blog';
          console.warn(isBlog ? 'Featured Blog' : 'Featured Collection', ': navigation buttons not found', { nextButton, prevButton, block: this.block });
          return;
        }

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: {
            el: this.block.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        try {
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();

          // const focusableElements = FoxTheme.a11y.getFocusableElements(this);

          // focusableElements.forEach((element) => {
          //   element.addEventListener('focusin', () => {
          //     const slide = element.closest('.swiper-slide');
          //     this.sliderInstance && this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          //   });
          // });

          this.calcNavButtonsPosition();
          if (this.tagName.toLowerCase() !== 'featured-blog') {
            this.fixQuickviewDuplicate();
          }
        } catch (error) {
          const isBlog = this.tagName.toLowerCase() === 'featured-blog';
          console.error(isBlog ? 'Featured Blog' : 'Featured Collection', ': Error initializing slider', error);
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const isBlog = this.tagName.toLowerCase() === 'featured-blog';
        const firstMedia = this.querySelector(isBlog ? '.article-card__media' : '.product-card__image-wrapper');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}

// Supporto per featured-blog usando lo stesso codice
if (!customElements.get('featured-blog')) {
  customElements.define(
    'featured-blog',
    class FeaturedBlog extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Sempre blog per questo elemento
        const isBlog = true;
        
        this.selectors = {
          sliderWrapper: '.featured-blog__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.block = this.closest('.featured-blog__content');
        
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        if (!this.sliderWrapper) {
          console.warn('Featured Blog: sliderWrapper not found');
          return;
        }

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items) || 3;
        this.tabletItems = parseInt(this.dataset.tabletItems) || 2;
        this.laptopItems = this.tabletItems;
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (typeof window.FoxTheme === 'undefined' || typeof window.FoxTheme.Carousel === 'undefined') {
          console.warn('Featured Blog: FoxTheme.Carousel not available');
          return;
        }

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);
        this.init();
      }

      init() {
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;
        
        if (!this.block) {
          console.warn('Featured Blog: block container not found');
          return;
        }

        const nextButton = this.block.querySelector(this.selectors.nextEl);
        const prevButton = this.block.querySelector(this.selectors.prevEl);
        
        if (!nextButton || !prevButton) {
          console.warn('Featured Blog: navigation buttons not found', { nextButton, prevButton, block: this.block });
          return;
        }

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          pagination: {
            el: this.block.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.laptopItems,
            },
            1280: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        try {
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();

          this.calcNavButtonsPosition();
        } catch (error) {
          console.error('Featured Blog: Error initializing slider', error);
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.article-card__media');
        const controls = this.block.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }
    }
  );
}
